import { useMutation } from "@tanstack/react-query";

import ky from "@/shared/api";
import dom from "@/shared/helper/dom.helper.ts";

// Ручка отдаёт готовый PDF, а не base64 в JSON, поэтому забираем blob.
// Первое скачивание по заказу дольше остальных: payments-service идёт за
// печатной формой в WebKassa и только потом кэширует её у себя.
export function useFiscalCheckDownload() {
  return useMutation<Blob, unknown, { orderId: number }>({
    mutationFn: ({ orderId }) =>
      ky
        .get(
          `https://gateway.maguya.kz/payment/shift/ticket/${orderId}/pdf`,
          { timeout: 60 * 1000 },
        )
        .blob(),
    onSuccess: (blob, { orderId }) => {
      dom.saveFileFromBlob(`Фискальный чек ${orderId}`, blob);
    },
  });
}
